<div class="topline">
  <h1 class="header">Manage Customers</h1>
  <div class="rightfabs">
    <button mat-fab (click)="playHelpMovie()"><mat-icon>movie</mat-icon></button>
    <button mat-fab (click)="addUser()"><mat-icon>add</mat-icon></button>
  </div>
</div>
<form class="filters" [formGroup]="form">
  <input class="search" #search matInput placeholder="Search users by name, email, phone number, SSN...">
  <mat-select class="partner" formControlName="partner" name="partner">
    <mat-option selected [value]="0">All Partners</mat-option>
    @for (partner of partners; track partner; let i = $index) {
      <mat-option [value]="i+1">{{partner.name}}</mat-option>
    }
  </mat-select>
</form>
<div class="wholescreen">
  @if (items.data.length === 0 && !loading) {
    <span>No customers match your search criteria.</span>
  }
  @if (items.data.length > 0) {
    <div class="scroll-container" (scroll)="onScroll($event)">
      <table class="table" mat-table matSort [dataSource]="items">
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Created</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.createdAt | date: 'mediumDate'}}</td>
        </ng-container>
        <ng-container matColumnDef="partnerImage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Partner</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">
            <div class="partnercell">
              <img class="partnerimage" [src]="item.partnerImage">
              <span>{{item.partnerName}}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="signedUpBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Signed Up By</th>
          <td class="cell clickable" mat-cell *matCellDef="let item" (click)="signedUpByClicked(item)">{{item.signedUpBy}}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">First Name</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.firstName}}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Last Name</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.lastName}}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Email</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.email}}@if (item.isVerifiedEmail) {
            <mat-icon class="checkicon">check</mat-icon>
          }</td>
        </ng-container>
        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Phone Number</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.phoneNumber}}@if (item.isConfirmed) {
            <mat-icon class="checkicon">check</mat-icon>
          }</td>
        </ng-container>
        <ng-container matColumnDef="address1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Address 1</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.address1}}</td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">City</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.city}}</td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">State</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.state}}</td>
        </ng-container>
        <ng-container matColumnDef="postalCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">ZIP Code</th>
          <td class="cell" mat-cell *matCellDef="let item" (click)="userEdit(item)">{{item.postalCode}}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td class="cell" mat-cell *matCellDef="let item">
            <button (click)="$event.stopPropagation()" mat-button [matMenuTriggerFor]="transactionMenu" [matMenuTriggerData]="{item: item}"><mat-icon class="more" matTooltip="Actions">more_vert</mat-icon></button>
          </td>
        </ng-container>
        <mat-menu #transactionMenu="matMenu">
          <ng-template matMenuContent let-item="item">
            <button mat-menu-item (click)="userLogin(item)">Login as User</button>
            <button mat-menu-item (click)="userEdit(item)">Modify User Profile</button>
            <button mat-menu-item (click)="editUserEmail(item)">Edit User Email</button>
            <button mat-menu-item (click)="loginHistory(item)">View Login History</button>
            @if (canSetProductEligibility()) {
              <button mat-menu-item (click)="setProductEligibility(item)">Set product eligibility</button>
            }
            <button
              mat-menu-item
              [matMenuTriggerFor]="brandHistoryMenu"
              [matMenuTriggerData]="{user: item}"
            >Brand History</button>
            <mat-divider></mat-divider>
            @if (item.isActivatedUser) {
              <button mat-menu-item (click)="changePartner(item)">Change Partner</button>
            }
            @if (item.isActivatedUser) {
              <button mat-menu-item (click)="sendPasswordReset(item)">Send Password Reset Email</button>
            }
            @if (isSuperAdmin) {
              <button mat-menu-item (click)="setPassword(item)">Set Password</button>
            }
            @if (isSuperAdmin && plaidSandboxToolsEnabled) {
              <button mat-menu-item (click)="openPlaidSandboxTools(item)">Plaid Sandbox Tools</button>
            }
            @if (item.isActivatedUser) {
              <button mat-menu-item (click)="disableUser(item)">Disable User</button>
            }
            @if (!item.isActivatedUser) {
              <button mat-menu-item (click)="enableUser(item)">Enable User</button>
            }
          </ng-template>
        </mat-menu>
        <mat-menu #brandHistoryMenu="matMenu">
          <ng-template matMenuContent let-user="user">
            <div class="brand-history-list">
              @if (getBrandHistory(user).length === 0) {
                <div class="brand-history-empty">
                  No brand history
                </div>
              }
              @for (historyItem of getBrandHistory(user); track historyItem) {
                <div class="brand-history-item">
                  @if (historyItem.brandLogoUrl) {
                    <img
                      class="brand-history-logo"
                      [src]="historyItem.brandLogoUrl"
                      [alt]="historyItem.brandName"
                      (error)="onBrandHistoryLogoError(historyItem)"
                      >
                  }
                  <div class="brand-history-details">
                    <span class="brand-history-name">{{historyItem.brandName}}</span>
                    <span>Joined {{historyItem.joinedAt | date:'medium'}}</span>
                    @if (historyItem.leftAt) {
                      <span>Left {{historyItem.leftAt | date:'medium'}}</span>
                    }
                    @if (!historyItem.leftAt) {
                      <span>Current</span>
                    }
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </mat-menu>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr [matTooltip]="rows.isActivatedUser ? '' : 'User is disabled'" [class]="rows.isActivatedUser ? 'listitem' : 'listitem strikethrough'" mat-row *matRowDef="let rows; columns: columnsToDisplay"></tr>
      </table>
      @if (loading) {
        <div class="loading-indicator">
          Loading more items...
        </div>
      }
    </div>
  }
  @if (iFrameSource) {
    <div class="iframewrapper">
      <h2>Logged in as {{iFrameTitle}}</h2>
      <button mat-raised-button color="primary" (click)="closeIframe()"><mat-icon>drag_indicator</mat-icon>Close</button>
      <!--
      <iframe height="800" width="500" [src]="iFrameSource" id="iframe"></iframe>
      -->
    </div>
  }
</div>
